/** @format */

import { ProductPrice } from './product-price.interface';

export interface DefiningAttributeProperty {
  available?: boolean;
  description?: string;
  name: string;
  productPrice?: ProductPrice;
  sequence?: string | number;
  swatch?: string;
  value: string;
}
